/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Menu_Support_HintInputs */



/**
* | output |
* | --- |
* | "Ask the team and other admins on Discord" |
*
* @param {Marketing_Menu_Support_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const marketing_menu_support_hint = /** @type {((inputs?: Marketing_Menu_Support_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Menu_Support_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Спросите команду и других администраторов в Discord")
	return /** @type {LocalizedString} */ ("Ask the team and other admins on Discord")
});